//src/app/+not-found.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center justify-center min-h-dvh bg-gradient-to-br from-[#0a0806] via-[#1a1410] to-[#0a0806] text-white p-6">
      <div className="text-center max-w-md space-y-6">
        {/* 404 Number */}
        <h1 className="font-serif text-8xl font-normal text-[#ffb85e] mb-2">404</h1>

        {/* Message */}
        <div className="space-y-2">
          <h2 className="text-2xl font-light text-white">Page Not Found</h2>
          <p className="text-white/40 font-light leading-relaxed">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
          <button
            onClick={() => navigate('/')}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-[#ffb85e] text-[#1a1410] rounded-xl font-light hover:bg-[#ffc77e] transition-colors focus-visible:ring-2 focus-visible:ring-[#ffb85e] focus-visible:outline-none"
            aria-label="Go to home page"
            style={{ touchAction: 'manipulation' }}
          >
            <Home size={18} />
            <span>Go Home</span>
          </button>
          <button
            onClick={() => navigate(-1)}
            className="flex items-center justify-center gap-2 px-6 py-3 bg-white/5 border border-white/10 text-white rounded-xl font-light hover:bg-white/10 transition-colors focus-visible:ring-2 focus-visible:ring-[#ffb85e] focus-visible:outline-none"
            aria-label="Go back to previous page"
            style={{ touchAction: 'manipulation' }}
          >
            <ArrowLeft size={18} />
            <span>Go Back</span>
          </button>
        </div>
      </div>
    </div>
  );
}
